import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import phoneicon from '../../prelogin/public/img/phone.png';
import whatsappicon from '../../prelogin/public/img/whatsapp.png';


class Whatsapp extends PreLoginPage {
render(){
    return(
        <div>
            <div id="whatsapp" style={{marginTop:'25px',textAlign:this.props.align,maxWidth:this.props.maxWidth}}>
            
            <img src={phoneicon} alt="Call icon" style={{margin:'5px',padding:"5px",border:"2px solid white",borderRadius:'30px 30px 30px 30px',background:this.props.background || "transparent"}}></img>
            
            <img src={whatsappicon} alt="Whatsapp icon" style={{margin:'5px',padding:"5px",border:"2px solid white",borderRadius:'30px 30px 30px 30px',background:this.props.background || "transparent"}}></img>
           
            <span style={{marginLeft:'5px',color:'#fff',marginTop:'5px',color:this.props.background || "#fff"}}>+91 9884400755</span>
        </div>
        </div>
    )
}
}

export default Whatsapp;


// WEBPACK FOOTER //
// ./src/views/login/Whatsapp.js